import { render, staticRenderFns } from "./ContentsForm.vue?vue&type=template&id=27cf718e"
import script from "./ContentsForm.vue?vue&type=script&lang=js"
export * from "./ContentsForm.vue?vue&type=script&lang=js"
import style0 from "./ContentsForm.vue?vue&type=style&index=0&id=27cf718e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports